// menuIcons
import searchIcon from '../images/windows-icon/search.svg';
import cromeIcon from '../images/windows-icon/cromeIcon.png';
import mailIcon from '../images/windows-icon/mailIcon.png';
import explorerIcon from '../images/windows-icon/explorerIcon.png';
import msedgeIcon from '../images/windows-icon/msedgeIcon.png';
import msstoreIcon from '../images/windows-icon/storeIcon.png';
import skypeicon from '../images/windows-icon/skypeicon.png';
import msoffice from '../images/windows-icon/msoffice.png';

// Pinned Items
import clendar from '../images/windows-icon/calender.png';
import outlook from '../images/windows-icon/Outlook.png';
import phone from '../images/windows-icon/phoneIcon.png';
import todoIcon from '../images/windows-icon/todoIcon.png';
import cortanaIcon from '../images/windows-icon/cortanaIcon.png';
import spotify from '../images/windows-icon/spotify.png';
import pinterest from '../images/windows-icon/pinterest.png';
import picsart from '../images/windows-icon/picsart.png';
import tiktok from '../images/windows-icon/tiktok.png';
import netflix from '../images/windows-icon/netflix.png';
import opera from '../images/windows-icon/opera.png';
import photoshop from '../images/windows-icon/photoshop.webp';
import vscodeIcon from '../images/windows-icon/vscodeIcon.png';
import nodejsIcon from '../images/windows-icon/nodejsIcon.png';
import ubuntu from '../images/windows-icon/ubuntu.png';
import weather from '../images/windows-icon/weather.png';
import itunes from '../images/windows-icon/itunes.png';
import camera from '../images/windows-icon/camera.png';

// Recomended Icons
import msOnedrive from '../images/windows-icon/msOnedrive.png';
import msword from '../images/windows-icon/msword.png';
import settingIcon from '../images/windows-icon/settingIcon.png';
import powerpoint from '../images/windows-icon/powerpoint.png';
import gethelp from '../images/windows-icon/gethelp.png';

// statusIcon
import wifiIcon from '../images/windows-icon/wifi.svg';
import volumeIcon from '../images/windows-icon/volume.svg';
import drpdwnIcon from '../images/windows-icon/expand-arrow.svg';

export const IconMenuAPI = [
    { mIcon: searchIcon },{ mIcon: mailIcon},
    { mIcon: msedgeIcon },{ mIcon: msstoreIcon },{ mIcon: skypeicon },
    { mIcon: msoffice },{ mIcon: cromeIcon },{ mIcon: explorerIcon }
];

export const StatusIconAPI = [
    { stIcon: drpdwnIcon },{ stIcon: wifiIcon },{ stIcon: volumeIcon } 
];

export const PinAPIOne = [
    { pIcon: clendar, text: "Calender" },{ pIcon: outlook, text: "Outlook" },{ pIcon: phone, text: "Your Phone" },
    { pIcon: todoIcon, text: "Todo" },{ pIcon: cortanaIcon, text: "Cortana" }, { pIcon: camera, text: "Camera" }
];

export const PinAPITwo = [
    { pIcon: spotify, text: "Cjvefy" },{ pIcon: pinterest, text: "Pinterest"},{ pIcon: picsart, text: "PicsArt"},
    { pIcon: netflix, text: "Cjveflix"},{ pIcon: tiktok, text: "TikTok"},{ pIcon: itunes, text: "ITunes"}
];

export const PinAPIThree = [
    { pIcon: opera, text: "Opera" },{ pIcon: photoshop, text: "Photoshop" },{ pIcon: vscodeIcon, text: "VSCode" },
    { pIcon: nodejsIcon, text: "Node JS" },{ pIcon: ubuntu, text: "Ubuntu" },{ pIcon: weather, text: "Weather" }
];

export const RecAPIOne = [
    { rIcon:  msOnedrive, text:"Onedrive - Carlos J Vargas E"},{ rIcon:  msword, text: "MS Word - Final project"}
];

export const RecAPITwo = [
    { rIcon:  settingIcon, text: "Settings"},{ rIcon:  powerpoint, text: "PowerPoint - Portafolio project"}
];

export const RecAPIThree = [
    { rIcon: gethelp, text: "Get Hepl or Send Feedback - Regarding Issues" }
];